'use strict';

var angular = require('angular');
var _ = require('lodash');
var RomSummaryThematicChartsDirective = function RomSummaryThematicChartsDirective(OpportunityTrendsChart, LineGraphChart, RomSummaryChartsTooltipService, BrushSelectionFilterFactory, romSummaryChartsDataService) {
  return {
    restrict: 'E',
    template: require('../templates/rom-summary-thematic-charts.html'),
    controller: 'RomSummaryThematicChartsController',
    scope: {
      grouping: '@',
      label: '@',
      chartTitle: '@',
      chartView: '=',
      filterType: '@',
      brushFilterChanged: '='
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var chart;
      var config = {
        forceWidth: true,
        brush: true
      };
      $scope.renderChartDataPresent = function (data) {
        var initialRangeMax = $scope.chartView === 'OPPORTUNITY_TREND' ? data.length : data.reduce(function (cumulative, current) {
          return Math.max(cumulative, current.curveData.length);
        }, 0);
        chart.render(data, [0, initialRangeMax]);
        _.forEach($scope.selections, function (selection) {
          chart.setInitialSelection(selection);
        });
        if (romSummaryChartsDataService.getFilter($scope.filterType) === undefined) {
          chart.expandBrush();
        }
        setTimeout($scope.$emit.bind($scope, 'reload-carousel'));
      };
      function isNoDataMode() {
        return $scope.initData && $scope.initData.length === 0;
      }
      $scope.$watch('chartView', function (newValue, oldValue) {
        if (newValue === undefined || oldValue === undefined || newValue !== oldValue && isNoDataMode()) {
          return;
        }
        $scope.buildChart();
      });
      $scope.buildChart = function () {
        $scope.formatters = RomSummaryChartsTooltipService.getFormatters(_.snakeCase($scope.chartTitle).toUpperCase(), $scope.chartTitle, $scope.chartView);
        angular.element('[class*=' + _.kebabCase($scope.chartTitle) + '-chart-tooltip]').remove();
        chartElement.trigger('$destroy');
        chartElement.find('svg').empty();
        chart = romSummaryChartsDataService.getNewChart(chartElement, $scope.formatters[$scope.chartView], config, $scope.chartView);
        chart.on('rangechangeend', function (brushRanges) {
          if (!_.isEqual($scope.selections, brushRanges)) {
            $scope.selections = brushRanges;
            $scope.handleBrushEnd(brushRanges);
          }
        });
        if ($scope.data) {
          $scope.renderChart($scope.prepareDataForChart());
        } else if (!isNoDataMode()) {
          $scope.loadData();
        }
      };
      $scope.handleBrushEnd = function (brushes) {
        if ($scope.filterType) {
          var filterArguments = getFilterArguments(brushes);
          var brushFilter = new BrushSelectionFilterFactory($scope.filterType, filterArguments);
          $scope.brushFilterChanged(brushFilter);
        }
      };
      $scope.resetChart = function () {
        if (!isNoDataMode()) {
          $scope.selections = undefined;
          chart.resetBrushSelection();
        }
      };
      function getFilterArguments(brushes) {
        var fields = [];
        for (var index = 0, length = brushes.length; index < length; index++) {
          if (brushes[index]) {
            for (var brushIndex = brushes[index][0], brushEnd = brushes[index][1]; brushIndex < brushEnd; brushIndex++) {
              fields.push($scope.data[brushIndex][$scope.filterType]);
            }
          }
        }
        if (fields.length === $scope.data.length) {
          return [];
        }
        return fields;
      }
    }
  };
};
RomSummaryThematicChartsDirective.$inject = ['RomSummaryOpportunityTrendsChart', 'RomSummaryLineGraphChart', 'RomSummaryChartsTooltipService', 'BrushSelectionFilterFactory', 'RomSummaryChartsDataService'];
module.exports = RomSummaryThematicChartsDirective;